module.exports = __webpack_public_path__ + "7dc12a27e511c359faf55ba8bcd50a70.pdf";